import Vue from 'vue'
import PortalVue from 'portal-vue'
import state from 'lib/appState'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import select from 'select-dom'
import on from 'dom-event'

Vue.use(PortalVue)
Vue.component('content-drawer', {
  props: [
    'id',
    'title',
    'css',
    'product',
    'data'
  ],
  data () {
    return {
      state,
      showContent: false,
      inputChange: false
    }
  },
  computed: {
    isActive () {
      return this.state.activeDrawer === this.id
    },
    drawerClasses () {
      return {
        [`content-drawer--${this.id}`]: true,
        [`${this.css ? this.css : 'no-class'}`]: true
      }
    }
  },
  watch: {
    isActive (newValue) {
      setTimeout(() => {
        const contentsEl = this.$refs.contents
        const portalTarget = contentsEl ? this.$refs.contents.parentNode.parentNode : false
        let focusElements = portalTarget ? select.all('a, button, input', portalTarget) : false
        const searchField = portalTarget ? select('input', portalTarget) : false
        if (focusElements) {
          let lastFocusElement = focusElements[focusElements.length - 1]
          let nextFocusElement
          focusElements.map((el, key) => {
            if (key === 0) {
              el.focus()
            }
            on(el, 'keydown', (e) => {
              if (el === lastFocusElement && el !== focusElements[0] && e.keyCode === 9 && !e.shiftKey) {
                e.preventDefault()
                focusElements[0].focus()
              }
              if (searchField) {
                lastFocusElement = focusElements[focusElements.length - 2]
                on(searchField, 'change', (e) => {
                  e.preventDefault()
                  focusElements = select.all('a, button, input', portalTarget)
                  focusElements.map((element, index) => {
                    if (element === searchField) {
                      nextFocusElement = focusElements[index + 2]
                    }
                    on(element, 'keydown', (e) => {
                      if (e.keyCode === 27) {
                        this.handleContentClose()
                      }
                      if (element !== focusElements[0] && !nextFocusElement && e.keyCode === 9 && !e.shiftKey) {
                        e.preventDefault()
                        focusElements[0].focus()
                      }
                    })
                  })
                  if (nextFocusElement) {
                    this.inputChange = true
                    nextFocusElement.focus()
                    lastFocusElement = focusElements[focusElements.length - 1]
                    on(lastFocusElement, 'keydown', (e) => {
                      if (e.keyCode === 9 && !e.shiftKey) {
                        e.preventDefault()
                        focusElements[0].focus()
                      }
                    })
                  } else {
                    e.preventDefault()
                    focusElements[0].focus()
                    on(searchField, 'keydown', (e) => {
                      if (e.keyCode === 9 && !e.shiftKey) {
                        focusElements = select.all('a, button, input', portalTarget)
                        focusElements.map((element, index) => {
                          if (element === searchField) {
                            nextFocusElement = focusElements[index + 2]
                          }
                        })
                        if (!nextFocusElement) {
                          e.preventDefault()
                          focusElements[0].focus()
                        }
                      }
                    })
                  }
                })
                on(searchField, 'keydown', (e) => {
                  if (e.keyCode === 9 && !e.shiftKey && !nextFocusElement) {
                    e.preventDefault()
                    focusElements[0].focus()
                  }
                })
              } else {
                lastFocusElement = focusElements[focusElements.length - 1]
              }
              if ((focusElements[0] === lastFocusElement && e.keyCode === 9) || (el === focusElements[0] && e.shiftKey && e.keyCode === 9)) {
                e.preventDefault()
              }
              if (el === focusElements[0] && e.keyCode === 9 && e.shiftKey) {
                e.preventDefault()
                focusElements = select.all('a, button, input', portalTarget)
                lastFocusElement = focusElements[focusElements.length - 1]
                if (lastFocusElement.getAttribute('hidden') === 'hidden') {
                  lastFocusElement = focusElements[focusElements.length - 2]
                }
                lastFocusElement.focus()
              }
              if (e.keyCode === 27) {
                this.handleContentClose()
                this.app.modalToggleEl.focus()
              }
            })
          })
        }
      }, 500)
      return newValue ? disableBodyScroll(this.$refs.scroller) : clearAllBodyScrollLocks()
    }
  },
  methods: {
    handleClose () {
      this.state.activeDrawer = null
    },
    handleContentClose () {
      const focusEl = this.state.modalToggleEl
      this.showContent = false
      if (focusEl) {
        focusEl.focus()
      }
    }
  },
  mounted () {
    on(window, 'keyup', event => {
      if (event.keyCode === 27 && this.showContent) {
        this.handleContentClose()
      }
    })
  },
  template: `
    <mounting-portal mount-to="body" append name="drawer" ref="portal">
      <div>
        <transition name="fade" @after-enter="showContent = true">
          <div class="content-drawer fixed" :class="drawerClasses" key="drawer-fixed" v-if="isActive" aria-labelledby="content-drawer-title" role="dialog" aria-modal="true">
            <div class="content-drawer__backdrop" @click="handleContentClose"></div>
            <transition name="slide-in-right" appear @after-leave="handleClose">
              <div class="content-drawer__container" v-if="showContent" ref="scroller">
                <div class="content-drawer__title">
                  <h2 id="content-drawer-title" class="h4 uppercase font-sans" v-html="title"></h2>
                  <button aria-label="Close popup" class="close-btn absolute f aic jcc content-drawer__close-button js-search-close-button" @click.prevent="handleContentClose">
                    <svg viewBox="0 0 14 14" aria-hidden="true">
                      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close" x="0" y="0"></use>
                    </svg>
                  </button>
                </div>
                <div class="content-drawer__content">
                  <div class="content-drawer__data wrapper" v-if="data" v-html="data"></div>
                  <div class="wrapper" ref="contents" data-inner-render>
                    <slot>
                    </slot>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </transition>
      </div>
    </mounting-portal>`
})
